<template>
    <b-nav-item-dropdown
        ref="userMenu"
        v-b-tooltip.hover
        class="user-menu mt-1"
        toggle-class="user-menu-button"
        :title="`${user.firstName} ${user.lastName}`"
        right
        @shown="setIsShown(true)"
        @hidden="setIsShown(false)"
    >
        <template v-slot:button-content>
            <header-menu-opener
                id="user-menu-dropdown-button"
                v-slot:button-content
                :opened="isShown"
            />
        </template>

        <!-- dropdown-menu -->
        <b-dropdown-item
            v-if="isShowKpiDashboard"
            id="user-menu-dropdown-kpi-dashboard-link"
            @click.stop.prevent="showKpiDashboard"
        >
            {{ $translate('kpi_dashboard') }}
        </b-dropdown-item>

        <b-dropdown-item
            v-if="isAdminEmployee"
            id="user-menu-dropdown-admin-link"
            @click.stop.prevent="showAdminOperations"
        >
            {{ $translate('admin_operations') }}
        </b-dropdown-item>

        <b-dropdown-item
            v-if="!isFdaFriendly"
            id="user-menu-dropdown-tutorials-link"
            @click.stop.prevent="showTutorialsBrowser"
        >
            {{ $translate('help_center') }}
        </b-dropdown-item>

        <b-dropdown-item id="user-menu-dropdown-settings-link" @click.stop.prevent="showSettings">
            {{ $translate('settings') }}
        </b-dropdown-item>

        <b-dropdown-item
            id="user-menu-dropdown-terms-of-use-link"
            @click.stop.prevent="showTermsOfUse"
        >
            {{ $translate('terms_of_use') }}
        </b-dropdown-item>

        <b-dropdown-item id="user-menu-dropdown-about-link" @click.stop.prevent="showAbout">
            {{ $translate('about') }}
        </b-dropdown-item>

        <b-dropdown-item
            id="user-menu-dropdown-sign-out-link"
            href="#"
            @click.stop.prevent="signOut"
        >
            {{ $translate('sign_out') }}
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import UIUtils from '../../../business/utils/UIUtils'
import BackendProvider from '../../../business/services/BackendProvider'

import HeaderMenuOpener from '../HeaderMenuOpener'
import Utils from '../../../business/utils/Utils'
import { CLINIC_LOGO_MAX_UPLOAD_SIZE } from '../../../business/const'

export default {
    name: 'UserMenu',
    components: { HeaderMenuOpener },
    data: () => ({
        isShown: false
    }),
    computed: {
        ...mapState({
            user: state => state.common.user
        }),
        ...mapGetters({
            tenant: 'common/getTenant',
            isFdaFriendly: 'common/isFdaFriendly'
        }),
        isShowKpiDashboard() {
            return BackendProvider.isUserHaveKpiAccess()
        },
        isAdminEmployee() {
            return BackendProvider.isAdminEmployee()
        }
    },
    methods: {
        setIsShown(status) {
            this.isShown = status
        },
        showKpiDashboard() {
            window.location = window.origin + '/kpi/'
        },
        showAdminOperations() {
            this.$store.dispatch('navigation/navigateToAdminOperations')
        },
        showTutorialsBrowser() {
            this.$store.dispatch('navigation/navigateToHelpCenter')
        },
        showTermsOfUse() {
            UIUtils.showModal('termsOfUse')
        },
        showAbout() {
            UIUtils.showModal('about')
        },
        showSettings() {
            UIUtils.showModal('settings')
        },
        signOut() {
            this.$mainController.signOut()
        }
    }
}
</script>

<style lang="scss">
.user-menu {
    .dropdown-menu {
        width: 14rem;
        border: none;
        border-radius: 0;
        padding-top: 0.1rem;
    }

    .user-menu-button {
        min-width: 14rem;
        margin-right: 0;

        &::after {
            display: none;
        }
    }

    &.show {
        background-color: $dark-4;
    }
}
</style>
